<template>
  <base-modal :modal-id="modalId" centered size="lg">
    <template v-slot:header>
      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Login') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Login To') + ' ' }}
        {{
          domainBasedBrand ? ' ' + _T_DB(currentBrand, 'name') : _T('Go Order')
        }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <div class="authentication">
        <div class="row full-height-row">
          <div class="col-lg-12 p-0">
            <div
              class="auth-right"
              :class="[
                login_fail_message || login_success_message
                  ? 'message-shown'
                  : '',
                login_in_progress ? 'in-progress-shown' : '',
              ]"
            >
              <div>
                <div class="auth-bottom d-none d-lg-block pt-0">
                  <h6>{{ _T("Don't have an account") }}?</h6>
                  <button
                    class="btn btn-outline"
                    @click="proceedFurther('signup')"
                  >
                    {{ _T('Sign Up') }}
                  </button>
                </div>
                <div class="login-form">
                  <div
                    class="d-flex d-lg-none"
                    style="justify-content: space-between;"
                  >
                    <h2>
                      {{ _T('welcome back') }}
                    </h2>
                    <a
                      href="#"
                      class="close-modal"
                      @click="$bvModal.hide(modalId)"
                      ><svg width="14" height="14" fill="none">
                        <use xlink:href="#closeIcon"></use></svg
                    ></a>
                  </div>
                  <!-- <h6 class="d-none d-lg-block">
                    {{ _T('Enter your detail below') }}
                  </h6> -->
                  <h6 class="d-block d-lg-none">
                    {{ _T('Login with your email and password') }}
                  </h6>
                  <form class="default-form row">
                    <div
                      class="form-group col-lg-12"
                      v-if="!loginWithPhoneNumber"
                    >
                      <label>{{ _T('Email') }}</label>
                      <input
                        required
                        v-model="login"
                        type="text"
                        class="form-control"
                        :class="{ 'border-danger': errors.login }"
                        value=""
                        :placeholder="_T('Email')"
                        autocomplete="new-password"
                      />
                      <span
                        v-if="errors.login"
                        class="validation-error d-block pt-1"
                      >
                        {{ errors.login }}
                      </span>
                    </div>
                    <div
                      class="form-group col-lg-12"
                      v-if="loginWithPhoneNumber"
                    >
                      <label>{{ _T('Phone Number') }}</label>
                      <phone-number-input
                        @custom-input="payload => (phone_number = payload)"
                      />
                      <div
                        :class="{
                          'border rounded border-danger': errors.phone_number,
                        }"
                      ></div>
                      <span
                        v-if="errors.phone_number"
                        class="validation-error d-block pt-1"
                      >
                        {{ errors.phone_number }}
                      </span>
                    </div>
                    <div class="form-group col-lg-12">
                      <label>{{ _T('Password') }}</label>
                      <div
                        class="input-group"
                        :class="
                          errors.password
                            ? 'border rounded border-danger'
                            : 'mb-3'
                        "
                      >
                        <input
                          required
                          v-model="password"
                          class="form-control"
                          value=""
                          :type="passwordFieldType"
                          :placeholder="_T('Enter your password')"
                          autocomplete="new-password"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <img
                              src="/images/svg/account/eye.svg"
                              alt=""
                              @click="switchPassVisibility"
                          /></span>
                        </div>
                      </div>
                      <span
                        v-if="errors.password"
                        class="validation-error d-block pt-1 mb-3"
                      >
                        {{ errors.password }}
                      </span>
                      <div class="remember">
                        <label class="d-sm-none d-lg-inline-block">
                          <input
                            class="checkbox_animated"
                            type="checkbox"
                            checked
                          />
                          {{ _T('Remember me') }}
                        </label>
                        <a
                          href="javascript:void(0)"
                          @click.prevent="proceedFurther('forgot-password')"
                        >
                          {{ _T('Forgot Password?') }}
                        </a>
                      </div>
                    </div>
                    <div class="form-group col-lg-12">
                      <loader v-if="processInProgress(process)" />
                      <div class="single-row">
                        <button
                          type="button"
                          class="btn btn-outline btn-block"
                          @click.prevent="
                            loginWithPhoneNumber = !loginWithPhoneNumber
                          "
                        >
                          {{
                            loginWithPhoneNumber
                              ? _T('Login with Email')
                              : _T('Login with Phone')
                          }}
                        </button>
                        <progress-bar
                          v-if="processInProgress(process)"
                          :btn-large="true"
                        />
                        <button
                          v-else
                          class="btn btn-solid btn-block mt-0"
                          @click.prevent="validateForm"
                        >
                          {{ _T('Login') }}
                        </button>
                      </div>
                      <div
                        v-if="login_fail_message || login_success_message"
                        class="alert fade show mt-3"
                        :class="
                          login_fail_message
                            ? 'alert-danger'
                            : login_success_message
                            ? 'alert-success'
                            : ''
                        "
                        role="alert"
                      >
                        {{
                          login_fail_message
                            ? login_fail_message
                            : login_success_message
                            ? login_success_message
                            : ''
                        }}
                      </div>
                    </div>
                    <!-- <div class="divider"></div> -->
                    <!-- <button
                        type="button"
                        class="btn btn-primary btn-block d-none d-lg-block"
                      >
                        <img
                          src="/images/social/fb.svg"
                          class="img-fluid"
                          alt=""
                        />
                        {{ _T('Login With Facebook') }}
                      </button>
                      <div class="button-group d-flex d-lg-none">
                        <button type="button" class="btn btn-primary btn-block">
                          <img
                            src="assets/svg/social/fb.svg"
                            class="img-fluid"
                            alt=""
                          />{{ _T('Facebook') }}
                        </button>
                        <button type="button" class="btn btn-google btn-block">
                          <img
                            src="assets/svg/social/google.svg"
                            class="img-fluid"
                            alt=""
                          />{{ _T('Google') }}
                        </button>
                      </div> -->
                    <div
                      class="auth-bottom d-block d-lg-none pt-0 mobile-signup  col-lg-1"
                    >
                      <h6>{{ _T("Don't have an account") }}?</h6>
                      <div class="signupnow">
                        <a href="javascript:void(0)" @click="showModal()">
                          {{ _T('Sign Up') }}
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import { validateEmail, validatePhoneNumber } from '@/utils/main_utils'
import ProgressBar from '@/components/Elements/ProgressBar'
import BaseModal from '@/components/Modals/BaseModal'
import Loader from '@/components/Elements/Loader'
import PhoneNumberInput from '@/components/Elements/PhoneNumberInput.vue'
export default {
  name: 'Login',
  components: {
    ProgressBar,
    BaseModal,
    Loader,
    PhoneNumberInput,
  },
  data: () => ({
    login: '',
    password: '',
    passwordFieldType: 'password',
    process: 'login',
    errors: {},
    modalId: 'login',
    phone_number: '',
    loginWithPhoneNumber: false,
  }),
  computed: {
    ...mapGetters([
      'login_success_message',
      'login_fail_message',
      'login_in_progress',
      '_T',
      'processInProgress',
      'domainBasedBrand',
      '_T_DB',
      'currentBrand',
    ]),
  },
  watch: {
    login() {
      this.$store.dispatch('set_login_failure_message', '')
    },
  },
  methods: {
    resetLoginForm() {
      this.login = ''
      this.password = ''
      this.phone_number = ''
    },
    showModal() {
      this.$bvModal.show('signup')
      this.$bvModal.hide('login')
    },
    proceedFurther(modalToShow) {
      this.$bvModal.hide('login')
      this.$bvModal.show(modalToShow)
    },
    switchPassVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    validateForm() {
      this.errors = {}
      this.errors.count = 0
      if (!this.loginWithPhoneNumber) {
        if (!validateEmail(this.login)) {
          this.errors.login = this._T('Incorrectly formatted email')
          this.errors.count = 1
        }
      } else {
        if (!validatePhoneNumber(this.phone_number)) {
          this.errors.phone_number = this._T(
            'Incorrectly formatted phone number'
          )
          this.errors.count = 1
        }
      }
      if (!this.password.trim()) {
        this.errors.password = this._T('Password is required')
        this.errors.count = 1
      }
      if (this.errors.count === 0) {
        this.login_action()
      }
    },
    login_action() {
      if (this.errors.count == 0 && !this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        let login = ''
        if (this.loginWithPhoneNumber) {
          login = this.phone_number
            .toString()
            .replace(/\+/g, '')
            .replace(/\s/g, '')
        } else {
          login = this.login.toString().toLowerCase()
        }
        this.$store
          .dispatch('login', {
            login,
            password: this.password,
          })
          .then(() => {
            this.errors = {}
            this.resetLoginForm()
            this.$bvModal.hide(this.modalId)
            //reset guest checkout
            this.$store.commit('SET_GUEST_CHECKOUT', false)
            this.$store.commit('SET_GUEST_INFO', {})
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.authentication {
  background-color: $white !important;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  .full-height-row {
    @media (max-width: 575px) {
      height: 100%;
    }
  }
  .signup-form {
    height: 100vh;
    overflow: auto;
  }
  .auth-left {
    background-image: url('/images/login-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100vh;
    position: absolute;
    img {
      position: absolute;
      left: 8.33%;
      top: 5.67%;
    }
  }
  .login-logo {
    text-align: center;
    display: none;
  }
  .auth-right {
    display: flex;
    align-items: center;
    justify-content: center;
    height: unset;
    width: 100%;
    position: relative;
    a {
      font-weight: 500;
    }
    .login-form {
      width: $px420;
      ::placeholder {
        color: #ddd;
      }
      .header-mobile {
        display: none;
      }
      h2 {
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: $px20;
      }
      h6 {
        line-height: $px22;
        letter-spacing: 0.5px;
        color: $font-color;
        margin-bottom: calc(
          #{$px20} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      .remember {
        padding-bottom: $px5;
        label {
          color: $color-primary;
          font-weight: 500;
          margin-bottom: 0;
        }
        a {
          float: right;
        }
      }
      .divider {
        padding-top: $px24;
        position: relative;
        clear: both;
        height: 0;
        margin: $px33 0 $px9;
        border-top: $px1 solid $light-border;
        &::before {
          position: absolute;
          top: -$px11;
          left: 47%;
          font-size: $px13;
          line-height: $px22;
          letter-spacing: 0.5px;
          margin-left: -$px10;
          padding: 0 $px10;
          content: 'OR';
          color: $light-font;
          background: $white;
        }
      }
      .btn {
        padding: $px15 0;
        position: relative;
        text-transform: capitalize;
        i,
        img {
          position: absolute;
          font-size: $px22;
          top: 26%;
          left: 5%;
        }
        &.btn-google {
          margin-top: 0;
          margin-left: $px15;
          background: $light-border;
        }
      }
    }
    .auth-bottom {
      text-align: right;
      padding: 0;
      // padding: calc(#{$px25} + (50 - 25) * ((100vw - #{$px320}) / (1920 - 320)))
      //   0 calc(#{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
      h6 {
        font-weight: 300;
        letter-spacing: 0.5px;
        color: $font-color;
        display: inline-block;
        margin-right: $px10;
      }
    }
  }
  .button-group {
    align-items: center;
  }
  .default-form {
    .form-group {
      margin-bottom: 18px !important;
      .single-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: $px10;
        @media (max-width: 575px) {
          grid-template-columns: 1fr;
          grid-row-gap: $px10;
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .authentication {
    .auth-right {
      .login-form {
        .divider {
          margin: $px15 0 -$px8;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .authentication {
    position: fixed;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100vw;
    left: 0;
    top: 0;
    overflow: auto;
    .signup-form {
      height: auto;
    }
    > .row {
      width: 90vw;
    }
    .auth-left {
      display: none;
    }
    .login-logo {
      margin: calc(#{$px20} + (40 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
        0 calc(#{$px30} + (92 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
      display: block;
    }
    .auth-right {
      align-items: unset;
      height: auto;
      padding: 0 $px20;
      > div {
        width: 100%;
      }
      .login-form {
        width: 100%;
        .remember {
          margin-bottom: $px55;
        }
        h2 {
          margin-bottom: $px14;
        }
        .divider {
          margin: 16px 0 -$px6;
        }
      }
      .auth-bottom {
        position: relative;
        right: unset;
        text-align: left;
        top: unset;
        // margin-top: $px45;
        h6 {
          font-weight: 600;
          font-size: $px12 !important;
          line-height: $px17;
          text-align: center;
          letter-spacing: 0.02em;
          margin: 0;
          margin-right: $px5 !important;
        }
      }
      .login-form {
        .btn {
          i,
          img {
            left: 10%;
          }
        }
      }
    }
  }
}
@media (width: 640px) and (height: 360px) {
  .authentication {
    align-items: flex-start;
  }
}
@media (max-width: 575px) {
  .mobile-signup {
    display: grid !important;
    grid-template-columns: auto auto;
    margin-top: 29px;
    margin-bottom: unset;
    grid-gap: 6px;
    h6 {
      text-align: right !important;
      font-size: $px12 !important;
    }
    .signupnow {
      text-align: left;
      font-weight: bold;
    }
  }
  .authentication {
    padding: 1.5rem !important;
    > .row {
      width: 100vw;
    }
    .p-0 {
      padding: 0 $px15 !important;
    }
    .auth-right {
      padding: 0;
      .login-form {
        width: auto;
      }
    }
    &.sign-up {
      align-items: flex-start;
    }
  }
}
@media (max-width: 360px) {
  .mobile-signup {
    display: grid !important;
    grid-template-columns: auto auto;
    margin-top: 29px;
    margin-bottom: unset;
    grid-gap: 6px;
    text-align: right;
    .signupnow {
      text-align: left;
      font-weight: bold;
    }
    h6 {
      font-size: $px12 !important;
    }
  }
  .authentication {
    align-items: flex-start;
    .auth-right {
      .login-form {
        .btn {
          padding: $px15 0 $px15 0;
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .authentication {
    .signup-form {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.body-rtl {
  // @media (max-width: 575px) {
.default-form {
    .form-group {
      .input-group {
        input {
            border-left: none;
            border-right: 1px #edeff4 solid;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-top-right-radius: .375rem;
            border-bottom-right-radius: .375rem;
          }
          .input-group-append {
            .input-group-text {
              border-right: none;
              border-left: 1px #edeff4 solid;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
          }
        }
      }
    }
  }
  .authentication {
      .vue-tel-input {
        align-items: stretch;
        width: 100%;
        input {
          // text-align: right;
        }
      }
      .auth-right {
        .login-form {
          h6 {
            text-align: right;
          }
          .remember {
            a {
              float: left;
            }
          }
        }
      }
  }
}
  // }
</style>
